import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { FiPhone, FiMail, FiMapPin, FiClock } from 'react-icons/fi'
import Logo from './Logo'

const FooterContainer = styled.footer`
  background: var(--gradient-dark);
  color: var(--color-text-white);
  padding: 4rem 0 2rem;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba(59, 130, 246, 0.5), transparent);
  }
`

const FooterContent = styled.div`
  max-width: var(--container-max-width);
  margin: 0 auto;
  padding: 0 var(--container-padding);
`

const FooterGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 3rem;
  margin-bottom: 3rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
`

const FooterSection = styled.div`
  h3 {
    color: var(--color-text-white);
    margin-bottom: 1.5rem;
    font-size: 1.25rem;
  }

  p {
    color: rgba(255, 255, 255, 0.8);
    line-height: 1.6;
    margin-bottom: 1rem;
  }
`

const ContactInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

const ContactItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  color: rgba(255, 255, 255, 0.9);

  svg {
    color: var(--color-primary);
    flex-shrink: 0;
  }

  a {
    color: rgba(255, 255, 255, 0.9);
    text-decoration: none;
    transition: color 0.2s ease;

    &:hover {
      color: var(--color-primary);
    }
  }
`

const ServicesList = styled.ul`
  list-style: none;
  padding: 0;

  li {
    color: rgba(255, 255, 255, 0.8);
    margin-bottom: 0.5rem;
    padding-left: 1rem;
    position: relative;

    &::before {
      content: '•';
      color: var(--color-primary);
      position: absolute;
      left: 0;
    }
  }
`

const QuickLinks = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;

  a {
    color: rgba(255, 255, 255, 0.8);
    text-decoration: none;
    transition: color 0.2s ease;

    &:hover {
      color: var(--color-primary);
    }
  }
`

const FooterBottom = styled.div`
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
  }
`

const Copyright = styled.p`
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.875rem;
  margin: 0;
`

const FooterLogo = styled.div`
  margin-bottom: 1.5rem;
`

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear()

  return (
    <FooterContainer>
      <FooterContent>
        <FooterGrid>
          <FooterSection>
            <FooterLogo>
              <Logo />
            </FooterLogo>
            <p>
                          Profesjonalne usługi serwisowe dla firm w Trójmieście. 
            Specjalizujemy się w zaplanowanych pracach serwisowych, 
            instalacjach hydraulicznych, grzewczych oraz remontach.
            </p>
            <ContactInfo>
              <ContactItem>
                <FiPhone />
                <a href="tel:510184702">510 184 702</a>
              </ContactItem>
              <ContactItem>
                <FiMail />
                <a href="mailto:kontakt@fachfix.pl">kontakt@fachfix.pl</a>
              </ContactItem>
              <ContactItem>
                <FiMapPin />
                <span>Trójmiasto i okolice</span>
              </ContactItem>
              <ContactItem>
                <FiClock />
                <span>Pn-Pt 8:00-17:00</span>
              </ContactItem>
            </ContactInfo>
          </FooterSection>

          <FooterSection>
            <h3>Nasze usługi</h3>
            <ServicesList>
              <li>Instalacje hydrauliczne</li>
              <li>Instalacje grzewcze i C.O.</li>
              <li>Naprawy i wymiany armatury</li>
              <li>Serwis drzwi i bram</li>
              <li>Zaplanowane serwisy</li>
              <li>Drobne remonty</li>
              <li>Podwykonawstwo dla firm FM</li>
            </ServicesList>
          </FooterSection>

          <FooterSection>
            <h3>Dla kogo</h3>
            <ServicesList>
              <li>Centra handlowe</li>
              <li>Biurowce i kompleksy biurowe</li>
              <li>Obiekty przemysłowe</li>
              <li>Magazyny i hale</li>
              <li>Instytucje publiczne</li>
              <li>Firmy zarządzające nieruchomościami</li>
            </ServicesList>
          </FooterSection>

          <FooterSection>
            <h3>Szybkie linki</h3>
            <QuickLinks>
              <Link to="/">Strona główna</Link>
              <Link to="/uslugi">Usługi</Link>
              <Link to="/o-nas">O nas</Link>
              <Link to="/kontakt">Kontakt</Link>
            </QuickLinks>
          </FooterSection>
        </FooterGrid>

        <FooterBottom>
          <Copyright>
            © {currentYear} FachFIX. Wszystkie prawa zastrzeżone.
          </Copyright>
          <Copyright>
            Paweł Kawski | NIP: [do uzupełnienia]
          </Copyright>
        </FooterBottom>
      </FooterContent>
    </FooterContainer>
  )
}

export default Footer 